webpackJsonp([22738258146681],{

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var History = function History() {
	  return _react2.default.createElement(
	    "svg",
	    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
	    _react2.default.createElement(
	      "g",
	      null,
	      _react2.default.createElement("path", { d: "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z" })
	    )
	  );
	};
	
	exports.default = History;
	module.exports = exports["default"];

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _website = __webpack_require__(8);
	
	var _website2 = _interopRequireDefault(_website);
	
	var _ItemNews = __webpack_require__(99);
	
	var _ItemNews2 = _interopRequireDefault(_ItemNews);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(13);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Container = __webpack_require__(9);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _History = __webpack_require__(43);
	
	var _History2 = _interopRequireDefault(_History);
	
	var _SlideUp = __webpack_require__(5);
	
	var _SlideUp2 = _interopRequireDefault(_SlideUp);
	
	var _LinkTagTopic = __webpack_require__(75);
	
	var _LinkTagTopic2 = _interopRequireDefault(_LinkTagTopic);
	
	var _CenterWrap = __webpack_require__(21);
	
	var _CenterWrap2 = _interopRequireDefault(_CenterWrap);
	
	var _CenterDiv = __webpack_require__(15);
	
	var _CenterDiv2 = _interopRequireDefault(_CenterDiv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DivSVG = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ejr8nod0'
	})('svg{width:40rem;height:40rem;opacity:0.35;g{fill:', function (props) {
	  return props.theme.colors.cool.dark;
	}, ';}}position:absolute;top:-650px;left:100px;z-index:10;overflow:hidden;max-height:600px;@media (max-width:600px){max-height:560px;left:20px;top:-480px;svg{width:38rem;height:38rem;}');
	
	var Base = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ejr8nod1'
	})('position:relative;margin:0 auto;z-index:8;top:-2rem;padding-bottom:2rem;padding-left:3rem;padding-right:3rem;display:grid;grid-template-columns:repeat(1,1fr);grid-row-gap:2rem;max-width:', function (props) {
	  return props.theme.layout.big;
	}, ';@media (max-width:', function (props) {
	  return props.theme.breakpoints.m;
	}, '){grid-template-columns:1fr;}');
	
	var News = function News(_ref) {
	  var edges = _ref.data.allMarkdownRemark.edges;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'News | ' + _website2.default.siteTitle }),
	    _react2.default.createElement(
	      _Header2.default,
	      { slim: true, title: ':' + '\xA0' + ':' + '\xA0' + 'NEWS' + '\xA0' + ':' + '\xA0' + ':' },
	      'My Journey / Your Shortcut'
	    ),
	    _react2.default.createElement(
	      _SlideUp2.default,
	      { delay: 0, toY: '90px', fromX: '-90px' },
	      _react2.default.createElement(
	        _CenterWrap2.default,
	        null,
	        _react2.default.createElement(
	          _CenterDiv2.default,
	          null,
	          _react2.default.createElement(
	            DivSVG,
	            null,
	            _react2.default.createElement(_History2.default, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(_LinkTagTopic2.default, null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        Base,
	        null,
	        edges.map(function (post, index) {
	          return _react2.default.createElement(_ItemNews2.default, {
	            key: post.node.frontmatter.title,
	            path: post.node.fields.slug,
	            cover: post.node.frontmatter.cover.childImageSharp.sizes,
	            title: post.node.frontmatter.title,
	            date: post.node.frontmatter.date,
	            topic: post.node.frontmatter.topic,
	            timeToRead: post.node.timeToRead,
	            excerpt: post.node.excerpt,
	            tags: post.node.frontmatter.tags,
	            teams: post.node.frontmatter.teams,
	            delay: index
	          });
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = News;
	
	
	News.propTypes = {
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      edges: _propTypes2.default.array.isRequired
	    })
	  })
	};
	
	/* eslint no-undef: "off" */
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-news-jsx-9088a091115bed429cc6.js